// Seed values for the feasibility calculator.
// Sources:
//   - "Feasibility 1 into 3 65 Bluehills O'Halloran Hill.xlsx" (Tick Flick Feaso sheet)
//   - "STERLING 134 - New Home Estimate.PDF" (Burbank, Apr 2025)
//
// Tier 1 = rates and percentages that rarely change across projects.
// Tier 2 = dollar amounts / sizes that are project-level defaults, often overridden.
// Anything here can be overridden per-scenario via `inputs.overrides`.

export const TIER1_DEFAULTS = Object.freeze({
  stamp_duty_pct: 0.085,
  selling_cost_pct: 0.025,
  construction_contingency_pct: 0.02,
  land_loan_rate: 0.07,
  dev_loan_rate: 0.035,
  gst_margin_scheme: true,
});

export const TIER2_DEFAULTS = Object.freeze({
  dwelling_m2: 140,
  cost_per_m2: 2300,
  demolition: 20000,
  design_approvals: 20000,
  finance_fees: 30000,
  marketing: 0,
  authorities: 0,
  holding_months: 12,
});

// Subdivision fees stepped by resulting dwelling count.
// Sheet uses $55k for 1→3; steps are our estimate for adjacent cases.
export const SUBDIVISION_FEES_BY_DWELLINGS = Object.freeze({
  1: 0,
  2: 35000,
  3: 55000,
  4: 75000,
  5: 95000,
  6: 115000,
});

export function subdivisionFee(dwellings) {
  if (dwellings <= 1) return 0;
  if (SUBDIVISION_FEES_BY_DWELLINGS[dwellings] !== undefined) {
    return SUBDIVISION_FEES_BY_DWELLINGS[dwellings];
  }
  // Linear extrapolation beyond the table: each extra dwelling adds $20k.
  return 35000 + (dwellings - 2) * 20000;
}

// Scoring thresholds for the finder. Kept with defaults so the cost_library
// page can expose them alongside the rest.
export const SCORING_DEFAULTS = Object.freeze({
  min_profit_on_cost_pct: 0.15,
  cap_profit_on_cost_pct: 0.20,
  corner_block_points: 30,
  lot_size_points: 25,
  frontage_points: 20,
  profit_points: 25,
  frontage_min_by_dwellings: Object.freeze({ 2: 15, 3: 18, 4: 22 }),
});
